import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { COMPANY } from "@/lib/site";

export const PremiumExperience = () => {
  const { pathname } = useLocation();
  const reduceMotion = useReducedMotion();
  const [loading, setLoading] = useState(() => !sessionStorage.getItem("apl-intro-seen"));
  const [transitioning, setTransitioning] = useState(false);

  useEffect(() => {
    if (!loading) return undefined;
    const timer = window.setTimeout(() => {
      sessionStorage.setItem("apl-intro-seen", "1");
      setLoading(false);
    }, reduceMotion ? 120 : 1150);
    return () => window.clearTimeout(timer);
  }, [loading, reduceMotion]);

  useEffect(() => {
    if (loading || reduceMotion) return undefined;
    setTransitioning(true);
    const timer = window.setTimeout(() => setTransitioning(false), 560);
    return () => window.clearTimeout(timer);
  }, [pathname, loading, reduceMotion]);

  useEffect(() => {
    if (reduceMotion) return undefined;
    let frame;
    const onPointerMove = (event) => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(() => {
        const x = event.clientX / window.innerWidth - 0.5;
        const y = event.clientY / window.innerHeight - 0.5;
        document.documentElement.style.setProperty("--cursor-x", `${(x * 16).toFixed(2)}px`);
        document.documentElement.style.setProperty("--cursor-y", `${(y * 12).toFixed(2)}px`);
        document.documentElement.style.setProperty("--cursor-neg-x", `${(x * -22).toFixed(2)}px`);
        document.documentElement.style.setProperty("--cursor-neg-y", `${(y * -16).toFixed(2)}px`);
      });
    };
    window.addEventListener("pointermove", onPointerMove, { passive: true });
    return () => {
      window.cancelAnimationFrame(frame);
      window.removeEventListener("pointermove", onPointerMove);
    };
  }, [reduceMotion]);

  return (
    <>
      <AnimatePresence>
        {loading && (
          <motion.div
            className="apl-loader"
            initial={{ opacity: 1 }}
            exit={{ opacity: 0, transition: { duration: 0.45, ease: "easeOut" } }}
            aria-label="Memuat PT Animax Putra Lancar"
          >
            <motion.div
              className="apl-loader__mark"
              initial={{ opacity: 0, scale: 0.88, y: 10 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              transition={{ duration: 0.55, ease: [0.2, 0.8, 0.2, 1] }}
            >
              <img src={COMPANY.logos.aplTransparent} alt="" />
              <span>PT. ANIMAX PUTRA LANCAR</span>
            </motion.div>
            <motion.div
              className="apl-loader__line"
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ duration: 0.8, delay: 0.15, ease: [0.2, 0.8, 0.2, 1] }}
            />
          </motion.div>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {transitioning && (
          <motion.div
            key={pathname}
            className="page-transition-line"
            initial={{ scaleX: 0, opacity: 1 }}
            animate={{ scaleX: 1, opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5, ease: [0.2, 0.8, 0.2, 1] }}
          />
        )}
      </AnimatePresence>
    </>
  );
};
